// BEGIN WORKFLOW AREA string-imports FOR vue/add-view sdk/add-component
import { kratos_login_flow } from "./pages/login/LoginFlowForm.strings.ts";
import { kratos_recovery_flow } from "./pages/recovery/RecoveryFlowForm.strings.ts";
import { recovery_intro } from "./pages/recovery/RecoveryIntro.strings.ts";
import {
  settings_group_empty,
  settings_page,
  settings_password_recovery,
  settings_sessions,
  settings_tabs,
} from "./pages/settings/Settings.strings.ts";
import { settings_intro } from "./pages/settings/SettingsIntro.strings.ts";
import { kratos_registration_flow } from "./pages/registration/RegistrationFlowForm.strings.ts";
import { kratos_verification } from "./pages/verification/Verification.strings.ts";
import { kratos_verification_flow } from "./pages/verification/VerificationFlowForm.strings.ts";
import { login_intro } from "./pages/login/LoginIntro.strings.ts";
import { login_mfa_setup_required } from "./pages/login/Login.strings.ts";
import { registration_intro } from "./pages/registration/RegistrationIntro.strings.ts";
import {
  verification_intro,
  verification_verified,
} from "./pages/verification/VerificationIntro.strings.ts";
import { verify_wall_actions } from "./pages/verify-wall/VerifyWallActions.strings.ts";
import { verify_wall_blocked_body } from "./pages/verify-wall/VerifyWallBlockedBody.strings.ts";
import { verify_wall_intro } from "./pages/verify-wall/VerifyWallIntro.strings.ts";
import { verify_wall_verified_actions } from "./pages/verify-wall/VerifyWallVerifiedActions.strings.ts";
import { verify_wall_verified_intro } from "./pages/verify-wall/VerifyWallVerifiedIntro.strings.ts";
// END WORKFLOW AREA

export const auth_strings = {
  // BEGIN WORKFLOW AREA string-object FOR vue/add-view sdk/add-component
  kratos_login_flow,
  kratos_recovery_flow,
  recovery_intro,
  settings_group_empty,
  settings_intro,
  settings_page,
  settings_password_recovery,
  settings_sessions,
  settings_tabs,
  kratos_registration_flow,
  kratos_verification,
  kratos_verification_flow,
  login_intro,
  login_mfa_setup_required,
  registration_intro,
  verification_intro,
  verification_verified,
  verify_wall_actions,
  verify_wall_blocked_body,
  verify_wall_intro,
  verify_wall_verified_actions,
  verify_wall_verified_intro,
  // END WORKFLOW AREA
};
